import React from 'react';
import SimpleHero from '../components/SimpleHero/SimpleHero';
import FeatureList from '../components/Minimal/FeatureList';
import hidden from "../assets/images/hidden.png";
import hidden3 from "../assets/images/mobile-banking.png";
import hiddens from "../assets/images/piggy-bank.png";
import file from "../assets/images/file.png";
import money from "../assets/images/money.png";
import secure from "../assets/images/life-insurance.png";
import onlineImg from "../assets/images/Online.png";
import './Checking/Checking.css'

const Checking = () => {
  const faq = [
    { q: 'Are there monthly fees?', a: 'No, GN Bank checking has no monthly maintenance fees.' },
    { q: 'How do I get paid early?', a: 'Set up direct deposit with your employer. Funds may arrive earlier depending on the sender.' },
    { q: 'Is my money FDIC insured?', a: 'Yes, deposits are FDIC insured up to $250,000 per depositor, per account category.' },
  ];

  return (
    <>
      <SimpleHero
        title="Simple, modern checking"
        subtitle="Mobile and online banking. Get paid faster with direct deposit."
        primaryLabel="Open an account"
        primaryHref="/DirectDeposit"
        variant="sofi"
        imageSrc={onlineImg}
        imageAlt="Online banking preview"
        imageOn="right"
        tiltImage
        badges={["No monthly fees","Mobile & Online","FDIC insured"]}
      />

      {/* SoFi-like highlight pills */}
      <section className="section">
        <div className="gn-container check-pills">
          <span className="check-pill">No monthly fees</span>
          <span className="check-pill">Mobile & Online banking</span>
          <span className="check-pill">FDIC insured</span>
        </div>
      </section>

      {/* Expanded features grid */}
      <FeatureList
        items={[
          { icon: hidden, title: 'No monthly fees', desc: 'Keep more of your money—no surprises.' },
          { icon: hidden3, title: 'Mobile banking', desc: 'Pay bills, transfer, and manage on the go.' },
          { icon: hiddens, title: 'Automatic savings', desc: 'Make saving easy with transfers and round‑ups.' },
          { icon: file, title: 'e‑Statements', desc: 'Go paperless with secure access to statements.' },
          { icon: money, title: 'Bill pay', desc: 'Set up one‑time and recurring payments.' },
          { icon: secure, title: 'Security first', desc: 'Modern encryption and account alerts.' },
        ]}
      />

      {/* Steps to get started */}
      <section className="section">
        <div className="gn-container">
          <div className="check-steps">
            <div className="step-card">
              <div className="step-title">1. Open your account</div>
              <div className="step-desc">Apply online in minutes with basic info.</div>
            </div>
            <div className="step-card">
              <div className="step-title">2. Set up direct deposit</div>
              <div className="step-desc">Get your paycheck faster—no paper checks.</div>
            </div>
            <div className="step-card">
              <div className="step-title">3. Bank anywhere</div>
              <div className="step-desc">Use mobile and online banking to manage money.</div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section">
        <div className="gn-container faq">
          {faq.map((f, i) => (
            <div className="faq-item" key={i}>
              <div className="faq-q">{f.q}</div>
              <div className="faq-a">{f.a}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section className="section text-center">
        <div className="gn-container">
          <a className="btn btn-gn-primary" href="/DirectDeposit">Open an account</a>
        </div>
      </section>
    </>
  );
};

export default Checking;
